<template>
  <div class="columns mt-6 pt-6">
    <div
      class="column is-10-tablet is-offset-1-tablet is-4-desktop is-offset-4-desktop"
    >
      <div class="content">
        <h3 class="title is-3 has-text-centered">
          <b-icon class="mb-3" icon="exclamation-circle" size="is-large">
          </b-icon>
          <br />
          Der Standortmonitor ist derzeit aufgrund eines technischen Problems
          leider nicht erreichbar.
        </h3>
        <h5 class="subtitle is-5 has-text-centered mt-3">
          Wir arbeiten mit Hochdruck an einer Lösung.
        </h5>
        <p class="has-text-centered">
          Bei Fragen oder dringenden Anliegen können Sie uns per E-Mail unter
          <a
            href="mailto:support@standortmonitor.net?subject=Technische%20Probleme"
          >
            support@standortmonitor.net
          </a>
          oder telefonisch unter der
          <a href="tel:03024626614">030-246 266-14</a> erreichen."
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Technisches Problem | GOLDMEDIA',
  },
};
</script>

<style>
</style>
